// 存放Local Storage键值
export const ACCESS_TOKEN = 'Access-Token'
export const USER_INFO = 'uesr_info'
export const MENU_DISABLE = 'menu_disable'
export const PANES_CACHE = 'panes_cache'
export const PANES_HISTORY_CACHE = 'panes_history_cache'
export const MENUS_ACTIVE_ID_CACHE = 'menus_active_id_cache'
export const ACTIVE_KEY_CACHE = 'active_key_cache'
export const CLUSTER_PREFIX = 'clusterPrefix'
export const REFERRER = 'referrer'
export const LANGUAGE = 'language'
export const SYSTEM_CODE = 'system_code'
export const HOME_MENU_ID = 'home_menu_id'
export const STORE_AUTHORIZATION_NO_DISPLAY = 'store_authorization_no_display'
export const IS_SELLERWELL = /sellerwell.com/.test(location.hostname)
export const LOCAL_DEFAULT_CONFIG = 'local_default_config' // 本地默认配置: {}
export const SSO_SYS_USER_SAIL = 'bfe87cf3f863da8d'
